class TextWithMap {
  constructor($main) {
    this.initDomElements($main);
    this.domElements.previewImage.on('click', () => {
      this.showVideo();
    });
    this.domElements.btn.on('click', () => {
      this.showVideo();
    });
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;
    this.domElements.previewImage = this.domElements.main.find('.text-with-map__preview-image');
    this.domElements.btn = this.domElements.main.find('.text-with-map__advice');
    this.domElements.iframeContainer = this.domElements.main.find('.text-with-map__iframe-container');
    return true;
  }

  showVideo() {
    this.domElements.previewImage.fadeOut();
    this.domElements.btn.fadeOut();

    const contentEncoded = this.domElements.iframeContainer.text();

    console.log(contentEncoded);

    this.domElements.iframeContainer.html(contentEncoded);
    this.domElements.iframeContainer.css({opacity: 1});
  }
}

export default TextWithMap;
